import { cn } from '@/lib/utils';

import { BlockReferenceArray } from '@/components/cms/types/block';

import { SCRAPING_CARD_DATA_TRACKER_COMPONENT } from '@/decodo/blocks/ScrapingTemplateLibrary/consts';
import Card, { CardProps } from '@/decodo/components/atoms/Card';
import ImageStrapi, {
  ImageStrapiProps,
} from '@/decodo/components/atoms/Image/ImageStrapi';
import LinkButton, {
  LinkButtonProps,
} from '@/decodo/components/atoms/LinkButton';
import { LinkButtonStrapiProps } from '@/decodo/components/atoms/LinkButton/LinkStrapi';
import RichTextFieldStrapi, {
  RichTextFieldStrapiProps,
} from '@/decodo/components/atoms/RichTextField/RichTextFieldStrapi';
import { Text } from '@/decodo/components/atoms/Text';

type TagProps = {
  title: string;
};

export type ScrapingTemplateCardProps = {
  title: string;
  image: ImageStrapiProps;
  description: RichTextFieldStrapiProps;
  cta: LinkButtonStrapiProps;
  scraping_template_tags: BlockReferenceArray<TagProps>;
  cardProps?: CardProps;
  classNames?: {
    root?: string;
    content?: string;
    card?: CardProps['classNames'];
    button?: LinkButtonProps['classNames'];
  };
};

const ScrapingTemplateCard = ({
  title,
  image,
  description,
  cta,
  ...rest
}: ScrapingTemplateCardProps) => {
  return (
    <LinkButton
      href={cta.url}
      noStyles
      className={cn('h-full', rest.classNames?.card?.root)}
      data-tracker-component={SCRAPING_CARD_DATA_TRACKER_COMPONENT}
    >
      <Card
        hasHoverEffect
        hasShadow
        {...rest.cardProps}
        classNames={{
          ...rest?.cardProps?.classNames,
          ...rest.classNames?.card,
          root: cn(
            'px-6 py-8 flex flex-col flex-1 h-full content-between hover:bg-brand-25 dark:border-gray-dark-600',
            'dark:hover:bg-brand-975',
            rest.classNames?.card?.root,
            rest?.cardProps?.classNames?.root
          ),
        }}
      >
        <div className='flex flex-1 flex-col'>
          <div className='mb-4 flex items-center'>
            <ImageStrapi
              inner={{
                classNames: {
                  image: 'w-8 h-8 rounded-full mr-3',
                },
              }}
              block={image}
            />
            <Text className='text-h3'>{title}</Text>
          </div>

          <div
            className={cn(
              'text-body-l min-h-24 overflow-hidden font-mono text-gray-500',
              rest.classNames?.content
            )}
          >
            <RichTextFieldStrapi block={description} />
          </div>
        </div>
        <LinkButton
          classNames={{
            root: cn('w-full mt-6', rest.classNames?.button?.root),
            ...rest.classNames?.button,
          }}
          color={cta.color || 'primary'}
          href={cta.url}
          showRightChevron
        >
          {cta.text}
        </LinkButton>
      </Card>
    </LinkButton>
  );
};

export default ScrapingTemplateCard;
